import React, { useContext, useEffect } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import firebase from "../config"
import { AuthContext } from "./Auth";
import Button from '@material-ui/core/Button';
import LoginIcon from '@mui/icons-material/Login';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { isPlatform, getPlatforms } from '@ionic/react';



const Home = () => {
  const { currentUser } = useContext(AuthContext);

  // If user is logged in, always send them to the app content
  if (currentUser) {
    return <Redirect to="/trips/index" />;
  }

  // If not logged in, route based on platform
  if (isPlatform('ios') && isPlatform('hybrid')) {
    return <Redirect to="/IOS" />;
  } 
  
  if (isPlatform('android') && isPlatform('hybrid')) {
    return <Redirect to="/ANDROID" />;
  }

  // Default Web/Desktop view
  return (
    <div className="wrapper tp-home">
      <div className="homebuttons">
        <Button size="large" variant="outlined" startIcon={<LoginIcon />} href="/login">Login</Button>
        <br/><br/>
        <Button size="large" variant="outlined" startIcon={<LoyaltyIcon />} href="/subscribe">Subscribe</Button>
      </div>
    </div>
  );
};

export default Home;